const { loginPageHandler } = require('../handlers/Login/LoginPageHandler')

const loginMapping = {
    loginPage: loginPageHandler
}

module.exports = { loginMapping }